import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Col,
  ListGroup,
  ListGroupItem,
  Row,
} from 'react-bootstrap';
import _ from 'lodash';

const fields = [
  ['First name', 'details.firstname', 4],
  ['Last name', 'details.lastname', 4],
  ['Gender', 'details.gender', 4],
  ['Mobile', 'details.mobile', 4],
  ['Email', 'details.email', 4],
  ['National ID', 'details.nationalId', 4],
  ['Birth date', 'details.birthdate', 4],
  ['Country', 'details.country', 4],
  ['City', 'details.city', 4],
  ['Address', 'details.address', 8],
  ['Postal code', 'details.postalCode', 4],
];

const UserAccountDetails = ({ title, user }) => (
  <Card className="mb-4 user-profile-card">
    <Card.Header className="border-bottom">
      <h6 className="m-0">{title}</h6>
    </Card.Header>
    <ListGroup variant="flush">
      <ListGroupItem className="p-3">
        <Row>
          {fields.map(([label, path, width]) => {
            const value = String(_.get(user, path, '') || '').trim();
            return (
              <Col md={width} className="user-profile-field" key={path}>
                <span className="user-profile-label">{label}</span>
                <span className={value ? 'user-profile-value' : 'user-profile-value text-muted'}>
                  {value || 'Not provided'}
                </span>
              </Col>
            );
          })}
        </Row>
      </ListGroupItem>
    </ListGroup>
  </Card>
);

UserAccountDetails.propTypes = {
  title: PropTypes.string,
  user: PropTypes.object,
};

UserAccountDetails.defaultProps = {
  title: 'User profile',
  user: {},
};

export default UserAccountDetails;
